module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/trending-up-va.8460fb15.svg";